import React, {Component} from 'react';
import PropTypes from 'prop-types';

import FormSelect from "./FormSelect";

import {SUMMARIES} from '../../utilities/constants';
import {TEXT} from '../../utilities/strings';

/**
 * Component to render the Summary Select dropdown
 *
 * @example
 * <SummarySelect
 *   label={'Text To Display'}
 *   formId="ID of form element"
 *   formName={this.props.formName}
 *   value={this.state.summaryType}
 *   onChange={value => this.setState({summaryType: value})}
 *  />
 */
export default class SummarySelect extends Component {

  static propTypes = {
    value: PropTypes.string,
    formId: PropTypes.string.isRequired,
    formName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
  };

  render() {
    return (
      <FormSelect
        value={this.props.value}
        label={this.props.label}
        formId={this.props.formId}
        formName={this.props.formName}
        onChange={this.props.onChange}>

        <option value={SUMMARIES.SUMMARY}>{TEXT.summary_short}</option>
        <option value={SUMMARIES.DETAIL}>{TEXT.summary_detail}</option>

      </FormSelect>
    );
  }
}
